import querystring from 'query-string';
import DataStore from 'src/core/stores/data-store';
import FormStore from 'src/core/stores/form-store';
import { Languages } from 'src/i18n';

export enum EventType {
  ScheduledUpdate = 'Update',
  Announcement = 'Announcement',
}

export type AnnouncementLocalizedData = {
  language: Languages;
  text?: string;
  image?: string;
};

type AnnouncementLocalizedDataQueryItem = {
  language: Languages;
  text?: string;
  bannerImage?: number[];
};

export interface ScheduledEventSummary {
  id: string;
  type: EventType;
  createdOn: Date;
  announcementStartDate: Date;
  announcementEndDate: Date;
  scheduledUpdateStart?: Date;
  announcementDuration?: number;
}

export interface ScheduledEventItem extends ScheduledEventSummary {
  announcementLink?: string;
  announcementInfo: AnnouncementLocalizedData[];
}

export interface ScheduledEventQueryItem extends ScheduledEventSummary {
  announcementLink?: string;
  announcementInfo: AnnouncementLocalizedDataQueryItem[];
}

export class ScheduledEventSummaryStore extends DataStore<ScheduledEventSummary> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/scheduled-announcement`, []);
  }
}

export class ScheduledEventItemStore extends FormStore<ScheduledEventItem, ScheduledEventItem> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/scheduled-announcement`);
  }

  public async loadWithSelectedLanguages(id: string, language: Languages) {
    return await this.handleCallAsync(async () => {
      const params = querystring.stringify({
        language,
      });
      var response = await this.httpService.get<ScheduledEventQueryItem>(`${this.baseUrl}/${encodeURIComponent(id)}?${params}`);
      const result: ScheduledEventItem = {
        ...response.data,
        announcementInfo: response.data.announcementInfo.map((v) => ({
          language: v.language,
          text: v.text,
          image: v.bannerImage ? 'data:image/jpeg;base64,' + v.bannerImage : undefined,
        })),
      };
      this._state.set((s) => {
        s.item = result;
        return s;
      });
      return true;
    });
  }
}
